<template>
  <div class="upload-file">
    <el-upload multiple :action="uploadreal_path" :before-upload="handleBeforeUpload" :file-list="fileList"
      :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed" :on-success="handleUploadSuccess"
      :show-file-list="false" :headers="headers" :drag="drag" class="upload-file-uploader" ref="fileUpload"
      :accept="accept" v-if="showUpload">
      <!-- 上传按钮 -->
      <slot name="trigger">
        <el-button type="default" icon="el-icon-plus" size="small"></el-button>
      </slot>
      <!-- 上传提示 -->
      <span class="el-upload__tip fs14" slot="tip" v-if="showTip">
        （限制最大{{ fileSize }}M）
        <!-- 请上传
        <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
<template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
的文件 -->
      </span>
    </el-upload>

    <!-- 文件列表 -->
    <div class="upload-file-list el-upload-list el-upload-list--text" v-show="isShowList">
      <template v-if="image">
        <!-- <div class="mr-2 mb-2 relative overflow-hidden" v-for="(file, index) in fileList" :key="file.filePath" style="display: inline-block;width: 100px; height: 100px;">
          <el-image
            style="width: 100%;height: 100%;"
            :src="file.real_path"
            :preview-src-list="previewSrcList"
            fit="fill" 
          ></el-image>
          <span v-if="showUpload" class="absolute bg-blue-500" style="top: 0;right: 0;border-radius: 50%;width: 20px;height: 10px;">
            <i class="el-icon-close" @click="handleDelete(index)"></i>
          </span>
        </div> -->
        <ul class="el-upload-list el-upload-list--picture-card">
          <li v-for="(file, index) in fileList" :key="file.filePath" :tabindex="index" class="el-upload-list__item">
            <el-image :ref="`image-file-${index}`" class="el-upload-list__item-thumbnail" :src="file.real_path" :preview-src-list="previewSrcList"
              fit="fill"></el-image>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="onPerviewImage(index)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="handleDelete(index)">
                <i class="el-icon-circle-close"></i>
              </span>
            </span>
          </li>
        </ul>
      </template>
      <template v-else>
        <div v-for="(file, index) in fileList" :key="file.filePath"
          :class="[showUpload ? 'pl10 pr10 fileItem el-upload-list__item' : '']">
          <c-link :download="file[downloadKey]" :label="file[nameKey]"></c-link>
          <i v-if="showUpload" class="el-icon-delete" @click="handleDelete(index)"></i>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import common from '../../assets/js/common'

export default {
  name: "FileUpload",
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 0,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 50,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["doc", "docx", "xls", "xlsx", "ppt", "txt", "pdf", "png", "jpg", "jpeg", "zip"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 是否显示上传
    showUpload: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: false
    },
    isShowList: {
      type: Boolean,
      default: true
    },
    nameKey: {
      type: String,
      default: 'file_name'
    },
    downloadKey: {
      type: String,
      default: 'real_path'
    },
    image: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      uploadreal_path: "/api/media/upload", // 上传文件服务器地址
      headers: {
        Authorization: common.getToken(),
      }
    };
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
    // 选择文件类型
    accept() {
      return this.fileType.map((e) => `.${e}`).join(',');
    },
    fileList: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      }
    },
    previewSrcList() {
      return this.fileList.map((item) => item.real_path);
    }
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        const file_name = file.name.split('.');
        const fileExt = file_name[file_name.length - 1];
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
        if (!isTypeOk) {
          common.pcToastFail(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          common.pcToastFail(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      common.pcToastLoading("正在上传文件，请稍候...");
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      common.pcToastFail(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      common.pcToastFail("上传文件失败，请重试");
      common.pcToastClose();
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      if (res.errcode === 0) {
        // this.uploadList.push({
        //   "fileExt": res['fileExt'],
        //   "file_name": res['originalfile_name'],
        //   "filePath": res['filePath'],
        //   "fileSize": res['fileSize'],
        //   "real_path": res['file_name'],
        //   "id": res['id'] || undefined
        // });
        this.uploadList.push(res.data)
        this.$emit('upload', res);
        this.uploadedSuccessfully();
      } else {
        this.number--;
        common.pcToastClose();
        common.pcToastFail(res.msg);
        this.$refs.fileUpload.handleRemove(file);
        this.uploadedSuccessfully();
      }
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
      this.$emit("change", this.fileList);
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        console.log(this.fileList);
        this.fileList = this.fileList ? this.fileList.concat(this.uploadList) : [...this.uploadList]
        this.uploadList = [];
        this.number = 0;
        this.$emit("change", this.fileList);
        common.pcToastClose();
      }
    },
    // 获取文件名称
    getfile_name(name) {
      // 如果是url那么取最后的名字 如果不是直接返回
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1);
      } else {
        return name;
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    },
    onPerviewImage(index) {
      console.log(this.$refs[`image-file-${index}`][0]);
      this.$refs[`image-file-${index}`][0].clickHandler()
    }
  }
};
</script>

<style scoped lang="less">
.fileItem {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/ .el-link {
    width: calc(100% - 40px);
    justify-content: flex-start;
  }

  /deep/ .el-link--inner {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.upload-file-uploader {
  margin-bottom: 5px;

  /deep/ .el-upload {
    //width: 100%;
    .el-upload-dragger {
      width: 100% !important;
      height: auto !important;
      min-width: 360px;
      min-width: 180px;
    }
  }
}

.upload-file-list .el-upload-list__item {
  // border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;

  &:hover > .el-icon-delete {
    opacity: 1;
  }

  .el-icon-delete {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    opacity: 0;
    &:hover {
      color: red;
    }
  }
}

.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}

.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>
